// Langfuse REST API client — reads credentials from localStorage

function getCredentials() {
  return {
    host: localStorage.getItem('lf_host') || 'https://cloud.langfuse.com',
    pub: localStorage.getItem('lf_public_key') || '',
    sec: localStorage.getItem('lf_secret_key') || '',
  }
}

export function hasCredentials() {
  var c = getCredentials()
  return Boolean(c.pub && c.sec)
}

function authHeader() {
  var c = getCredentials()
  return 'Basic ' + btoa(c.pub + ':' + c.sec)
}

function friendlyError(status) {
  if (status === 401) return 'Your API credentials are incorrect or missing. Please check the keys in Settings.'
  if (status === 403) return 'Access denied. Your API key does not have permission to view this data.'
  if (status === 404) return 'Could not find your Langfuse project. Please verify the Host URL and API keys in Settings.'
  if (status === 429) return 'Too many requests — the dashboard is being rate limited. Please wait a moment and try refreshing.'
  if (status >= 500) return 'The analytics service is temporarily unavailable. Please try again in a few minutes.'
  return 'Could not load analytics data. Please check your connection and try again.'
}

async function apiFetch(path, params) {
  params = params || {}
  var c = getCredentials()
  var url = new URL(c.host + path)
  Object.entries(params).forEach(function(pair) {
    if (pair[1] != null) url.searchParams.set(pair[0], String(pair[1]))
  })
  var res
  try {
    res = await fetch(url.toString(), {
      headers: { Authorization: authHeader(), 'Content-Type': 'application/json' },
    })
  } catch (e) {
    throw new Error('Unable to reach the analytics service. Please check your internet connection.')
  }
  if (!res.ok) throw new Error(friendlyError(res.status))
  return res.json()
}

async function fetchAllPages(path, baseParams, maxPages) {
  maxPages = maxPages || 5
  var first = await apiFetch(path, Object.assign({}, baseParams, { page: 1, limit: 100 }))
  var all = (first.data || []).slice()
  var total = Math.min((first.meta && first.meta.totalPages) || 1, maxPages)

  if (total > 1) {
    var pages = []
    for (var i = 0; i < total - 1; i++) {
      pages.push(apiFetch(path, Object.assign({}, baseParams, { page: i + 2, limit: 100 })))
    }
    var rest = await Promise.all(pages)
    rest.forEach(function(r) { all.push.apply(all, r.data || []) })
  }
  return all
}

export function getTraces(from, to) {
  return fetchAllPages('/api/public/traces', {
    fromTimestamp: from.toISOString(),
    toTimestamp: to.toISOString(),
  })
}

export function getObservations(from, to) {
  return fetchAllPages('/api/public/observations', {
    fromStartTime: from.toISOString(),
    toStartTime: to.toISOString(),
  })
}

export async function deleteTrace(traceId) {
  var c = getCredentials()
  var url = c.host + '/api/public/traces/' + traceId
  var res
  try {
    res = await fetch(url, {
      method: 'DELETE',
      headers: { Authorization: authHeader(), 'Content-Type': 'application/json' },
    })
  } catch (e) {
    throw new Error('Unable to reach the analytics service. Please check your internet connection.')
  }
  if (!res.ok) throw new Error(friendlyError(res.status))
}
